// removed by extract-text-webpack-plugin
module.exports = {"wrap":"_1Ktn3KQQCvEgciJER2rjUa","buttonWrap":"_15n_pnw5oWGj0mMaLVNG5G"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/SwitchPlans.scss
// module id = 2915
// module chunks = 0